import { GetterTypes } from '@/store-vuex/types';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Contact extends Vue {
    /**
       * Gets true if AppointmentParticipant step must be displayed
       *
       * @returns {boolean} true or false
       */
      public get showAppointmentParticipantStep(): boolean {
          return this.$store.getters[GetterTypes.showAppointmentParticipantStep];
      }
}
